(function () {
  if (window.tsBraxCartGuardReady) return;
  window.tsBraxCartGuardReady = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-brax-remove-build]');
    if (!button) return;
    event.preventDefault();
    const buildId = button.dataset.braxRemoveBuild;
    if (!buildId) return;
    if (!window.confirm('Remove the complete BRAX DSP configuration from your cart?')) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Could not read the cart.');
      const cart = await cartResponse.json();
      const updates = {};
      for (const item of cart.items) {
        if (item.properties?._brax_builder_id === buildId) updates[item.key] = 0;
      }
      if (!Object.keys(updates).length) throw new Error('This build is no longer in the cart.');
      const response = await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Could not remove the complete build.');
      window.location.assign('/cart');
    } catch (problem) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.alert(problem.message || 'Could not remove the complete build. Please try again.');
    }
  });
}());
